exports.onRouteUpdate = ({ location }) => {
  const { hash } = location;
  if (hash && typeof window !== 'undefined') {
    // Small delay to ensure page is rendered
    setTimeout(() => {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }, 100);
  }
};
